import { Component } from '@angular/core';
import { MandatoryCheckTemplateGridCellActions } from '../../models/mandatory-check-template-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-mandatory-checks-templates-actions-renderer',
  templateUrl: './mandatory-checks-templates-actions-renderer.component.html',
  styleUrls: ['./mandatory-checks-templates-actions-renderer.component.scss'],
})
export class MandatoryChecksTemplatesTableActionsRendererComponent {
  params?: MandatoryCheckTemplateGridCellActions;

  // gets called once before the renderer is used
  agInit(params: MandatoryCheckTemplateGridCellActions): void {
    this.params = params;
  }

  deleteClick() {
    this.params?.onDeleteClick(this.params.data.id!);
  }
}
